import {useCustomerStore} from "~/modules/common/stores/customers";
import {storeToRefs} from "pinia";

export default defineNuxtRouteMiddleware((to, from) => {
    if (!to.meta) {
        console.log('no meta');
        return;
    }
    if(to.name === "nutzungsbedingungen"){
        return navigateTo('/', {redirectCode: 302 })
    }

    const requiredRoles: string[] = <string[]>to.meta['roles'];

    if (!requiredRoles || requiredRoles.length === 0) {
        return;
    }
    const { $authStore} = useNuxtApp();
    const user = $authStore;
    const {currentCustomer: userCustomer} = storeToRefs(useCustomerStore());
    const {data, signOut} = useAuth();

    if (!!data.value?.error) {
        console.log('signing out unauthenticated user');
        signOut({callbackUrl: "/"});
    } else if (!user.currentUser || user.currentUser.id !== data.value?.user.id) {
        return user.setUser(data.value?.user).then(_=> {
            let userRoles = userCustomer.value?.roles || [];

            if (to.name === "registration" && !userRoles.some(role => role.includes("REGISTERED"))) {
                // console.log("registration already finished");
                return navigateTo('/dashboard/aktuelles', { redirectCode: 302 });
            }

            if (to.name !== "registration" && userRoles.some(role => role.includes("REGISTERED"))) {
                console.log("must perform registration");
                if (!!to.name && to.name.toString().includes('basket')){
                    return navigateTo(`/registration?basketType=${to.query.type}`, { redirectCode: 302 })
                }
                return navigateTo('/registration', { redirectCode: 302 });
            }

            // TODO check roles
            return Promise.resolve(true);
        })
    } else if (!!user.currentUser) {
        let userRoles = userCustomer.value?.roles || [];

        if (to.name === "registration" && !userRoles.some(role => role.includes("REGISTERED"))) {
            // console.log("registration already finished");
            return navigateTo('/dashboard/aktuelles');
        }

        if (to.name !== "registration" && userRoles.some(role => role.includes("REGISTERED"))) {
            // console.log("must perform registration");
            return navigateTo('/registration');
        }

    }
    if(to.name === "dashboard") {
        return navigateTo('/dashboard/aktuelles');
    }
})
